
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import 'styles/image-container.pcss'

const ImageContainer = ({ src = '', alt, caption, absolute }) => (
    <div
        className={classNames(
            'image-container',
            { 'image-container--absolute': absolute }
        )}
    >
        <figure>
            <img src={src} alt={alt} />
            {caption ? <figcaption>{caption}</figcaption> : null}
        </figure>
    </div>
)

ImageContainer.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    caption: PropTypes.string,
    absolute: PropTypes.bool
}

export default ImageContainer
